"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _HBCheckbox = _interopRequireDefault(require("../HBCheckbox/HBCheckbox"));
var _shared = require("../../utils/shared.utils");
/* eslint-disable jsx-a11y/no-static-element-interactions */

function HBTableCheckbox(_ref) {
  var checked = _ref.checked,
    indeterminate = _ref.indeterminate,
    onChange = _ref.onChange,
    testIdName = _ref.testIdName,
    margin = _ref.margin;
  return /*#__PURE__*/_react["default"].createElement("div", {
    onClick: _shared.stopEventPropagation,
    onKeyPress: _shared.stopEventPropagation
  }, /*#__PURE__*/_react["default"].createElement(_HBCheckbox["default"], {
    margin: margin,
    size: "xs",
    testIdName: testIdName,
    checked: checked,
    onChange: onChange,
    indeterminate: indeterminate
  }));
}
var _default = exports["default"] = HBTableCheckbox;
//# sourceMappingURL=HBTableCheckbox.js.map